import api from './api';

export interface ReceivableOrder {
  id: string;
  order_number: string;
  customer_name: string;
  order_date: string | null;
  due_date: string | null;
  total_amount: number;
  /** Days past due on the report's as-of date, not on today. */
  days_overdue: number;
}

export interface ReceivablesReport {
  as_of: string;
  total_amount: number;
  total_count: number;
  orders: ReceivableOrder[];
}

export const receivablesService = {
  // Receivables are a balance, not a flow: they are stated as of a single date
  // rather than summed across a period, so only the range's end date is sent.
  get: async (endDate: string): Promise<ReceivablesReport> => {
    const response = await api.get<ReceivablesReport>('/reports/receivables', {
      params: { endDate },
    });
    return response.data;
  },
};
